import { gql } from '@apollo/client';

export default gql`
  query getAllTodos($page: Int, $limit: Int, $filter: Filter) {
    getAllTodos(page: $page, limit: $limit, filter: $filter) {
      payload {
        _id
        title
        item
      }
      page
      limit
    }
  }
`;
